module.exports = __webpack_public_path__ + "static/media/logo.3998d86c.svg";